import React from "react";
import { MentionsInput, Mention } from "react-mentions";
import { mentionsStyles } from "./styles/mention";
import { flattenIndicators } from "../../utils/groupMention";
import { useNewton } from "../../store/NewtonContext";

const Input = React.forwardRef(
  ({ handleEnterKey, onChange, textareaRef, value, ...props }, ref) => {
    const { setMessage, setMessageHtml } = useNewton();
    const markup = "@[__display__](__id__)";

    const assignRef = React.useCallback(
      (node) => {
        if (typeof ref === "function") {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }

        if (textareaRef) {
          textareaRef.current = node;
        }
      },
      [ref, textareaRef]
    );

    return (
      <MentionsInput
        allowSpaceInQuery
        allowSuggestionsAboveCursor
        forceSuggestionsAboveCursor
        inputRef={assignRef}
        onChange={(_event, newValue, newPlainTextValue) => {
          setMessageHtml(newValue);
          setMessage(newPlainTextValue);
          onChange?.(newPlainTextValue);
        }}
        onKeyDown={handleEnterKey}
        placeholder="Message"
        style={mentionsStyles}
        value={value ?? ""}
        {...props}
      >
        <Mention
          appendSpaceOnAdd
          className="border-primary300 bg-grayTrue900 text-primary200 relative z-[1] rounded-sm border text-sm"
          data={(query, cb) => cb(flattenIndicators(query))}
          displayTransform={(_id, display) => `/${display}`}
          markup={markup}
          renderSuggestion={(_entry, _search, highlightedDisplay) => {
            return (
              <div className="hover:bg-gray100 w-full cursor-pointer rounded-sm p-2">
                <div className="text-gray900 text-xs font-semibold">
                  {highlightedDisplay}
                </div>
              </div>
            );
          }}
          trigger="/"
        />
      </MentionsInput>
    );
  }
);

Input.displayName = "NewtonInput";

export default Input;
